import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register the admin PWA service worker when the user navigates to /admin.
// On the public site we deliberately skip it so visitor browsing stays
// network-fresh and unaffected.
if ("serviceWorker" in navigator) {
  const registerIfAdmin = () => {
    if (window.location.pathname.startsWith("/admin")) {
      navigator.serviceWorker.register("/admin-sw.js", { scope: "/admin" }).catch(() => {});
    }
  };
  window.addEventListener("load", registerIfAdmin);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
